export default __webpack_public_path__ + "static/media/safari-zone.02503ad8.png";